import { useContext, useEffect, useState } from "react";
import CurrentContext from "./CurrentContext";

export default function AxisGizmo() {
  const cap_t = 0.002;
  const cap_e = 0.002;
  const l = 5;
  const deg90 = Math.PI / 2;
  const [showAxis, setShowAxis] = useState(false);
  const { setIsEditEnabled } = useContext(CurrentContext);

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (
        (event.altKey && event.key === "z") ||
        event.key === "Z" ||
        event.which === 90 // Alt + z (90)
      ) {
        // setShowAxis((prevKeyPressed) => !prevKeyPressed);
        setIsEditEnabled((prev) => !prev);
      }
      if (
        (event.altKey && event.key === "g") ||
        event.key === "G" ||
        event.which === 90 // Alt + z (90)
      ) {
        setShowAxis((prevKeyPressed) => !prevKeyPressed);
        // setIsEditEnabled((prev) => !prev);
      }
    };

    window.addEventListener("keydown", handleKeyPress);
    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, []);

  return (
    <>
      <group visible={showAxis}>
        {/* height */}
        <mesh rotation={[0, 0, 0]}>
          <cylinderGeometry attach="geometry" args={[cap_t, cap_e, l, 16]} />
          <meshStandardMaterial attach="material" color="#0000ff" />
        </mesh>

        {/* width */}
        <mesh rotation={[deg90, 0, deg90]}>
          <cylinderGeometry attach="geometry" args={[cap_t, cap_e, l, 16]} />
          <meshStandardMaterial attach="material" color="#ff0000" />
        </mesh>
        <mesh position={[-1, 0, 0]} rotation={[deg90, 0, deg90]}>
          <cylinderGeometry attach="geometry" args={[cap_t, cap_e, l, 16]} />
          <meshStandardMaterial attach="material" color="#884400" />
        </mesh>
        <mesh rotation={[deg90, 0, deg90]}>
          <cylinderGeometry attach="geometry" args={[cap_t, cap_e, l, 16]} />
          <meshStandardMaterial attach="material" color="#ff0000" />
        </mesh>

        {/* depth */}
        <mesh rotation={[deg90, 0, 0]}>
          <cylinderGeometry attach="geometry" args={[cap_t, cap_e, l, 16]} />
          <meshStandardMaterial attach="material" color="#00ff00" />
        </mesh>
      </group>
    </>
  );
}
